export const buildId = '__BUILDID__';
export const minfyJsId = '__BUILDID:MINIFYJS__';
export const optimizeCssId = '__BUILDID:OPTIMIZECSS__';
export const parse5Version = '__VERSION:PARSE5__';
export const rollupVersion = '__VERSION:ROLLUP__';
export const sizzleVersion = '__VERSION:SIZZLE__';
export const terserVersion = '__VERSION:TERSER__';
export const typescriptVersion = '__VERSION:TYPESCRIPT__';
export const vermoji = '__VERMOJI__';
export const version = '__VERSION:STENCIL__';
export const versions = {
  stencil: version,
  parse5: parse5Version,
  rollup: rollupVersion,
  sizzle: sizzleVersion,
  terser: terserVersion,
  typescript: typescriptVersion,
};
